module.exports = __webpack_public_path__ + "img/jianchalv.50bec446.png";